import { TextInputProps, TextProps } from '../../atoms';
import { DropDownItemProps } from '../DropDownItem';

type DropDownListInternalProps = {
  dropDownItem?: DropDownItemProps;
  searchInput?: TextInputProps; // MANUAL OVERRIDE
  bottomBarText?: TextProps; // MANUAL OVERRIDE
};

type DropDownListPropsValues = {
  'Default': DropDownListInternalProps; // MANUAL OVERRIDE
  'Search': DropDownListInternalProps; // MANUAL OVERRIDE
};

const propValues: DropDownListPropsValues = {
  'Default': { // MANUAL OVERRIDE
    dropDownItem: {
      type: 'DefaultText',
      state: 'Unselected',
    },
  },
  'Search': { // MANUAL OVERRIDE
    dropDownItem: {
      type: 'DefaultText',
      state: 'Unselected',
    },
    searchInput: {
      type: 'TextCentered',
      error: 'None',
      size: 'S',
    },
    bottomBarText: {
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
      align: 'Left',
    },
  },
};

const getProps = (type: string): DropDownListInternalProps => {
  const values: DropDownListInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
